<template>
  <div class="customer-statistics">
    <a-card title="预收款汇总表">
      <!-- 搜索表单 -->
      <div class="search-form">
        <a-form layout="horizontal">
          <a-row :gutter="16">
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="客户编码" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-input v-model="queryParam.customerNo" placeholder="请输入客户编码" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="交易类型" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-select v-model="queryParam.transactionType" placeholder="请选择交易类型">
                  <a-select-option :value="1">消费</a-select-option>
                  <a-select-option :value="2">充值</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="支付方式" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-select v-model="queryParam.paymentMethod" placeholder="请选择支付方式">
                  <a-select-option :value="1">支付宝</a-select-option>
                  <a-select-option :value="2">微信</a-select-option>
                  <a-select-option :value="3">三方充值</a-select-option>
                  <a-select-option :value="4">Payme</a-select-option>
                  <a-select-option :value="5">余额</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="12" :xs="24">
              <a-form-item label="交易时间" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
                <a-range-picker
                  v-model="queryParam.transactionTimeRange"
                  :placeholder="['开始时间', '结束时间']"
                  :show-time="{ format: 'HH:mm', defaultValue: [$moment('00:00:00', 'HH:mm:ss'), $moment('23:59:59', 'HH:mm:ss')] }"
                  format="YYYY-MM-DD HH:mm:ss"
                  @change="onDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" :xs="24" class="form-actions-col">
              <a-button type="primary" icon="search" @click="searchQuery(1)" style="margin-right: 8px;">
                查询
              </a-button>
              <a-button icon="reload" @click="searchReset(getDefaultQueryParam(), 1)" style="margin-right: 8px;">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 统计条 -->
      <div class="statistics-bar">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12" :xs="12">
            <a-card size="small" :bordered="false" class="stat-card original">
              <a-statistic
                :value="statistics.totalOriginalAmount || 0"
                :precision="2"
                suffix="UZS"
                :valueStyle="{ color: '#1890ff' }"
                class="inline-stat"
              >
                <template #title>
                  <span class="stat-title">期初金额</span>
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :md="6" :sm="12" :xs="12">
            <a-card size="small" :bordered="false" class="stat-card add">
              <a-statistic
                :value="statistics.totalAddAmount || 0"
                :precision="2"
                suffix="UZS"
                :valueStyle="{ color: '#52c41a' }"
                class="inline-stat"
              >
                <template #title>
                  <span class="stat-title">本期增加</span>
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :md="6" :sm="12" :xs="12">
            <a-card size="small" :bordered="false" class="stat-card reduce">
              <a-statistic
                :value="statistics.totalReduceAmount || 0"
                :precision="2"
                suffix="UZS"
                :valueStyle="{ color: '#fa541c' }"
                class="inline-stat"
              >
                <template #title>
                  <span class="stat-title">本期减少</span>
                </template>
              </a-statistic>
            </a-card>
          </a-col>
          <a-col :md="6" :sm="12" :xs="12">
            <a-card size="small" :bordered="false" class="stat-card final">
              <a-statistic
                :value="statistics.totalFinalAmount || 0"
                :precision="2"
                suffix="UZS"
                :valueStyle="{ color: '#722ed1' }"
                class="inline-stat"
              >
                <template #title>
                  <span class="stat-title">期末金额</span>
                </template>
              </a-statistic>
            </a-card>
          </a-col>
        </a-row>
      </div>

      <!-- 表格列表 -->
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        bordered
        rowKey="customerNo"
        @change="handleTableChange"
        :scroll="{ x: tableScrollX }"
      >
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { TableListMixin } from '@/situation/mixins/tableListMixin'
import { filterObj } from 'utils/util'

export default {
  name: 'CustomerStatistics',
  mixins: [TableListMixin],
  computed: {
    tableScrollX() {
      return this.columns.reduce((sum, col) => sum + (col.width || 120), 0)
    }
  },
  data() {
    return {
      queryParam: {},
      loading: false,
      columns: [
        {
          title: '客户编码',
          dataIndex: 'customerNo',
          key: 'customerNo',
          align: 'center',
          fixed: 'left',
          width: 140
        },
        {
          title: '客户名称',
          dataIndex: 'userName',
          key: 'userName',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'mobile',
          key: 'mobile',
          align: 'center',
          width: 140
        },
        {
          title: '总下单数',
          dataIndex: 'sumOrderCount',
          key: 'sumOrderCount',
          align: 'center',
          width: 120
        },
        {
          title: '期初金额',
          dataIndex: 'openingBalance',
          key: 'openingBalance',
          align: 'center',
          width: 120
        },
        {
          title: '本期增加',
          dataIndex: 'incomeAmount',
          key: 'incomeAmount',
          align: 'center',
          width: 120
        },
        {
          title: '本期减少',
          dataIndex: 'expenseAmount',
          key: 'expenseAmount',
          align: 'center',
          width: 120
        },
        {
          title: '期末金额',
          dataIndex: 'closingBalance',
          key: 'closingBalance',
          align: 'center',
          width: 120
        },
        // {
        //   title: '净变动',
        //   dataIndex: 'netChange',
        //   key: 'netChange',
        //   align: 'center',
        //   width: 120
        // }
      ],
      url: {
        // 后端需提供该接口，返回分页的客户统计数据
        selectData: '/ndt/customerFundDetail/customerStatistics/page',
        // 统计总计接口
        statistics: '/ndt/customerFundDetail//customerStatistics/total'
      }
    }
  },
  created() {
    const defaults = this.getDefaultQueryParam()
    this.queryParam = { ...this.queryParam, ...defaults }
  },
  mounted() {
    // 页面加载时获取统计数据
    this.dataStatistics()
  },
  methods: {
    getDefaultQueryParam() {
      const end = this.$moment().endOf('day')
      const start = this.$moment().subtract(3, 'month').startOf('day')
      return {
        transactionTimeRange: [start, end],
        startTime: start.format('YYYY-MM-DD HH:mm:ss'),
        endTime: end.format('YYYY-MM-DD HH:mm:ss')
      }
    },
    onDateChange(value, dateString) {
      this.queryParam.startTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    getQueryParams() {
      // 复用TableListMixin的参数结构，并移除不需要传递的时间范围字段
      var param = Object.assign({}, this.queryParam, this.isorter)
      param.field = this.getQueryField()
      param.current = this.ipagination.current
      param.size = this.ipagination.pageSize
      delete param.transactionTimeRange
      if (this.superQueryParams) {
        param['superQueryParams'] = encodeURI(this.superQueryParams)
        param['superQueryMatchType'] = this.superQueryMatchType
      }
      return filterObj(param)
    }
  }
}
</script>

<style scoped>
.customer-statistics {
  background: #fff;
}
.search-form {
  margin-bottom: 16px;
}
.search-form .ant-row {
  display: flex;
  flex-wrap: wrap;
}
.form-actions-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 4px;
}
@media (max-width: 1200px) {
  .form-actions-col {
    justify-content: flex-start;
  }
}

/* 统计条样式 */
.statistics-bar {
  margin: 12px 0 16px;
}
.inline-stat {
  display: flex;
  align-items: center;
  gap: 8px;
}
.inline-stat .ant-statistic-title {
  margin-bottom: 0;
}
.stat-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.stat-card.original .ant-statistic-title {
  color: #1890ff;
}
.stat-card.add .ant-statistic-title {
  color: #52c41a;
}
.stat-card.reduce .ant-statistic-title {
  color: #fa541c;
}
.stat-card.final .ant-statistic-title {
  color: #722ed1;
}
</style>
